export default "__VITE_ASSET__4207dbf4__"